import { canonicalSportForFilter } from "./sportNormalization";

/** Progress may show cycling performance only for cycling, or labeled under all sports. */
export function showCyclingProgressAnalytics(sportFilter) {
  return sportFilter === "cycling" || sportFilter === "all" || sportFilter == null || sportFilter === "";
}

export function cyclingProgressIsScopedToCyclingOnly(sportFilter) {
  return sportFilter === "all" || sportFilter == null || sportFilter === "";
}

export function canonicalActivitySport(activity) {
  if (activity && typeof activity === "object") return canonicalSportForFilter(activity);
  return canonicalSportForFilter({ sport: activity || "" });
}

export function isCyclingActivity(activity) {
  return canonicalActivitySport(activity) === "cycling";
}

export function positiveMetric(value) {
  const number = typeof value === "string" && value.trim() !== "" ? Number(value) : value;
  return typeof number === "number" && Number.isFinite(number) && number > 0;
}

export function activityHasSamples(activity) {
  return Array.isArray(activity?.samples) && activity.samples.length > 0;
}

export function activityAfterRename(current, updated) {
  const currentSamples = Array.isArray(current?.samples) ? current.samples : [];
  const updatedSamples = Array.isArray(updated?.samples) ? updated.samples : [];
  const storedCount = Number(updated?.sample_count || 0);
  if (currentSamples.length > 0 && updatedSamples.length === 0 && storedCount > 0) {
    return { ...updated, samples: currentSamples };
  }
  return updated;
}

export function showCyclingPowerZones(activity, ftp) {
  if (!isCyclingActivity(activity)) return false;
  if (!activity?.has_power) return false;
  if (!activityHasSamples(activity)) return false;
  return positiveMetric(ftp);
}

export function showCyclingPowerCurve(activity) {
  if (!isCyclingActivity(activity)) return false;
  if (!activity?.has_power) return false;
  if (!activityHasSamples(activity)) return false;
  return Array.isArray(activity.power_curve) && activity.power_curve.length > 0;
}

export function showCyclingPowerPeaks(activity) {
  return isCyclingActivity(activity) && !!activity?.has_power && activityHasSamples(activity);
}

/** Cadence wording follows the sport. Swimming, walking, and hiking do not use cycling rpm. */
export function cadencePresentation(activity) {
  const sport = canonicalActivitySport(activity);
  if (sport === "cycling") {
    return { show: true, avgLabel: "Avg Cadence", maxLabel: "Max Cadence", unit: "rpm" };
  }
  if (sport === "running") {
    return { show: true, avgLabel: "Running cadence", maxLabel: "Max running cadence", unit: "spm" };
  }
  return { show: false, avgLabel: "", maxLabel: "", unit: "" };
}

export function showRecordedPowerSummary(activity) {
  const sport = canonicalActivitySport(activity);
  if (sport !== "cycling" && sport !== "running") return false;
  return !!activity?.has_power && (positiveMetric(activity.avg_power) || positiveMetric(activity.max_power));
}

export function showCyclingLoadMetrics(activity) {
  return isCyclingActivity(activity);
}
